import { configureStore, combineReducers, Action } from '@reduxjs/toolkit'
import ReduxThunk, { ThunkAction } from 'redux-thunk'
import patient from '../patients/patient-slice'
import patients from '../patients/patients-slice'
import appointment from '../scheduling/appointments/appointment-slice'
import appointments from '../scheduling/appointments/appointments-slice'
import title from '../page-header/title-slice'
import user from '../user/user-slice'
import breadcrumbs from '../breadcrumbs/breadcrumbs-slice'
import components from '../components/component-slice'
import patientData from '../patients/patientData-slice'
import patientGarmin from '../patients/patientGarmin-slice'
import userSession from '../login/userSession-slice'
import patientFiles from '../clinics/clinics-slice'
import vitalsMetaData from '../patients/vitalsMetaData-slice'
import userActivity from '../user/userActivity-slice'
import users from '../user/users-slice'
import groups from '../groups/groups-slice'
import videoChat from '../vdg-patients/common/video-chat/videoChat-slice'
import summaryHistory from '../patients/dashboard/summaryHistory-slice'
import summaryDiscussionHistory from '../patients/dashboard/summaryDiscussionHistory-slice'
import dashboard from '../dashboard/dashboard-slice'
import patientMessages from '../scheduling/appointments/patientMessages-slice'
import edanData from 'settings/edanDevices/edan-slice'
import patientDiagnosis from '../vdg-patients/vdg-patients-diagnosis-slice'
import hospitalization from '../vdg-patients/hospitalization/hospitalization-slice'
const reducer = combineReducers({
  patient,
  patients,
  edanData,
  title,
  user,
  userSession,
  appointment,
  appointments,
  breadcrumbs,
  components,
  patientFiles,
  patientData,
  patientGarmin,
  vitalsMetaData,
  userActivity,
  users,
  groups,
  videoChat,
  summaryHistory,
  summaryDiscussionHistory,
  dashboard,
  patientMessages,
  patientDiagnosis,
  hospitalization,
})

const store = configureStore({
  reducer,
  middleware: [ReduxThunk],
})

export type AppDispatch = typeof store.dispatch
export type AppThunk = ThunkAction<void, RootState, null, Action<string>>
export type RootState = ReturnType<typeof reducer>

export default store
